module.exports = __webpack_public_path__ + "static/fraula-e932e97f18247acb01169f5e8bd59333.png";